import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { PaymentData } from 'src/app/model/stripe-models/payment/payment-data';
import { MatSelectChange } from '@angular/material/select';
import { SubscriptionData } from 'src/app/model/stripe-models/subscription/subscription-data';
import { forkJoin } from 'rxjs';
@Component({
    selector: 'app-dialog-abo-verwaltung',
    templateUrl: './dialog-abo-verwaltung.component.html',
    styleUrls: ['./dialog-abo-verwaltung.component.css'],
    standalone: false
})
export class DialogAboVerwaltungComponent implements OnInit {

  public activeOrg: any;
  public capacity: any;
  public ProductsListToggle: boolean = false;
  public availableProducts: any; //all products of the organisation
  public productFromListing: any; // all licenses of the organisation 
  public filteredProducts: any; // all none licensed products of the organisation
  public licensedProducts: any; // all licensed products fo this subscription
  public paymentData: PaymentData;
  public allPaymentData: PaymentData[] = [];
  public selectedProductId: string | null = null;
  public showAlternativePaymentMethods: boolean = false;
  public isPriorityLicense: boolean = false;
  loading: any = false;
  @Input() subscription: SubscriptionData;
  public selectedSubObject: any;

  constructor(
    private dialogService: DialogService,
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
    public headerService: HeaderServiceService,
    public router: Router,
    private stripeService: StripeService
  ) {
  }


  ngOnInit(): void {
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    this.availableProducts = this.productService.getProductsOfOrganisation(this.activeOrg);
    this.isPriorityLicense = this.checkPriorityLicense();

    this.intialize();
  }

  getSubscriptionCapacity(): any {
    this.loading = true;
    this.stripeService.getListingCurrentUsage(this.activeOrg, this.subscription.id)
      .pipe(finalize(() => { this.loading = false; }))
      .subscribe({
        next: (data) => {
          this.handleCapacityResult(data);
        },
        error: (err) => {
          console.error('Unexpected error while loading subscription capacity.', err);
        }
      });
  }

  onProductSelectionChange(event: any) {
    if (event.value === null || this.filteredProducts.some(p => p.id === event.value)) {
      this.selectedProductId = event.value;
    } else {
      this.selectedProductId = null;
    }
  }

  clearSelection(event: MouseEvent) {
    event.stopPropagation();
    this.selectedProductId = null;
  }

  openProductsListToggle() {
    if (this.isCapacityFull()) {
      this.showCapacityFullDialog();
    } else {
      this.ProductsListToggle = !this.ProductsListToggle;
      this.cdr.detectChanges();
    }
  }

  intialize() {
    this.loading = true;

    forkJoin({
      capacity: this.stripeService.getListingCurrentUsage(this.activeOrg, this.subscription.id),
      products: this.stripeService.getAllListingProductFromOrgId(this.activeOrg),
      payments: this.stripeService.getPaymentData(this.activeOrg, "")
    })
    .pipe(
      finalize(() => { 
        this.loading = false; 
        this.cdr.markForCheck();
      })
    )
    .subscribe({
      next: (results) => {
        this.handleCapacityResult(results.capacity);
        this.handleProductsListResult(results.products);
        this.handlePaymentResult(results.payments);
      },
      error: (err) => {
        console.error('Unexpected error in initialize:', err);
      }
    });
  }

  addOneEntry(): void {
    if (!this.activeOrg || !this.selectedProductId || !this.subscription?.id) {
      return;
    }
    this.dialogService
    .openConfirmDialog(
      'Möchten Sie dieses Produkt diesem Abonnement zuordnen?',
      'Abbrechen',
      'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) return;
      this.loading = true;
      this.stripeService.addProductsToListing(this.activeOrg, this.subscription.id, this.selectedProductId)
        .pipe(finalize(() => { this.loading = false;}))
        .subscribe({
          next: data => {
            if(data === null) return;
            if (data.status == 226) {
              this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Diese Abonnement ist voll');
              return;
            } else if (data?.status >= 400) {
              this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
              return;
            } 
            this.ProductsListToggle = false;
            this.intialize();
            if (this.selectedSubObject?.prioListing && this.selectedSubObject.prioListing.currentUsage < this.selectedSubObject.prioListing.listingCapacity) {
              this.askAndHandlePrioritization();
            } else {
              this.dialogService.openDialog('Neues Produkt lizenziert', 'Ihr Produkt ist nun mit Ihrem Abonnement lizenziert und auf dem Marktplatz verfügbar');
              this.selectedProductId = null;
            }
          }, 
          error: (err) => {
            console.error( 'Unexpected error while adding product to subscription.', err);
          }
      });
    });
  }

  removeEntry(product): void {
    if (!this.activeOrg || !product?.id || !this.subscription?.id) {
      return;
    }
    this.dialogService
    .openConfirmDialog(
      'Möchten Sie die Zuordnung dieses Produkts zu diesem Abonnement wirklich aufheben?',
      'Abbrechen',
      'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) {
        return;
      }
      this.loading = true;
      this.stripeService.removeProductFromListing(this.activeOrg, this.subscription.id, product.id)
        .pipe(finalize(() => { this.loading = false;}))
        .subscribe({
          next:  (data) => {
            if (data?.status >= 400) {
              console.error('Failed to remove product from subscription.', data);
              this.dialogService.openDialog('Produkt konnte nicht entfernt werden', 'Fehler beim Entfernen des Produkts aus dem Abonnement.');
            } else {
              this.dialogService.openDialog('Produkt ist nicht mehr lizenziert', 'Ihr Produkt ist nun nicht mehr für Ihr Abonnement lizenziert und wird vom Marktplatz entfernt.');
              this.intialize();
            }
          },
          // Fallback for unexpected errors that are not handled by the service. Service already handles expected HTTP errors.
          error: (err) => { console.error( 'Unexpected error while removing product from subscription.', err); }
        });
    });
  }

  getTotalVersionsCount(product: any): number {
    if (!product.productVariants) return 0;
    return product.productVariants.reduce((total: number, variant: any) => {
      return total + (variant.variantVersions?.length || 0);
    }, 0);
  }

  getPaymentData() {
    this.loading = true;
    this.stripeService.getPaymentData(this.activeOrg, "")
    .pipe(finalize(() => { this.loading = false; }))
    .subscribe({
      next: (data) => {
        this.handlePaymentResult(data);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Unexpected error while loading payment data.', err);
      }
    });
  }

  managePaymentMethods(change: MatSelectChange) {
    if (change) {
      this.showAlternativePaymentMethods = false;
      this.dialogService.openConfirmDialog('Zahlungsmethode wechseln', 'Abbrechen', 'Bestätigen', "Wollen Sie die Zahlungsmethode wirklich wechseln?").subscribe(confirmed => {
        if (confirmed) {
          let paymentId = change.value;
          this.stripeService.editSubscription(this.activeOrg, this.subscription.id, "?default_payment_method=" + paymentId).subscribe(data => {
            if (typeof data == "string") {
              this.subscription.paymentId = paymentId;
              this.allPaymentData.forEach(paymentCard => {
                if (paymentCard.id == paymentId) this.paymentData = paymentCard;
              });
              this.dialogService.openDialog('Zahlungsmethode wechseln', 'Ihre Zahlungsmethode wurde erfolgreich geändert.');
            }
            else this.dialogService.openDialog('Zahlungsmethode wechseln fehlgeschlagen.', 'Bitte versuchen Sie es später erneut.');
            this.cdr.detectChanges();
          })
        }
      });

    }
    else this.showAlternativePaymentMethods = !this.showAlternativePaymentMethods;
  }

  removePriorization(productId: number): void {
    if (!this.activeOrg || !this.selectedSubObject?.originListing?.subscriptionId) {
      return;
    }
    this.dialogService
    .openConfirmDialog(
      'Möchten Sie die Priorisierung für dieses Produkt aufheben?',
      'Abbrechen',
      'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) {
        return;
      }
      this.loading = true;
      this.stripeService.prioritizeProduct(this.activeOrg, this.selectedSubObject.originListing.subscriptionId, productId.toString(), false)
      .pipe(finalize(() => { this.loading = false;}))
      .subscribe({
        next: (prioritizeResponse) => {
          if (prioritizeResponse === null) return;
          if (prioritizeResponse?.status !== 200) {
            this.dialogService.openDialog(
              'Depriorisierung fehlgeschlagen',
              'Die Depriorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
            );
            return;
          } 
          this.dialogService.openDialog('Priorisierung aufgehoben', 'Das Produkt wird nicht mehr priorisiert angezeigt.');
          this.getSubscriptionCapacity();
          this.loadProductsList();
        },
        error: (err) => {
          console.error('Unexpected error while deprioritizing product.', err);
        }
      });
    });
  }

  addPriorization(): void {
    if (!this.activeOrg || !this.selectedProductId || !this.selectedSubObject?.originListing?.subscriptionId) {
      return;
    }
    this.dialogService
    .openConfirmDialog(
      'Möchten Sie dieses Produkt priorisieren?',
      'Abbrechen',
      'Bestätigen'
    )
    .subscribe((confirmed) => {
      if (!confirmed) {
        return;
      }
      this.loading = true;
      this.stripeService.prioritizeProduct(this.activeOrg, this.selectedSubObject.originListing.subscriptionId, this.selectedProductId, true)
      .pipe(finalize(() => { this.loading = false;}))
      .subscribe({
        next: (prioritizeResponse) => {
          if (prioritizeResponse === null) return;
          if (prioritizeResponse?.status !== 200) {
            this.dialogService.openDialog(
              'Priorisierung fehlgeschlagen',
              'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
            );
            return;
          } 
          this.selectedProductId = null;
          this.ProductsListToggle = false;
          this.dialogService.openDialog('Produkt priorisiert', 'Das Produkt wird jetzt priorisiert angezeigt.');
          this.getSubscriptionCapacity();
          this.loadProductsList();
        },
        error: (err) => {
          console.error('Unexpected error while prioritizing product.', err);
        }
      });
    });
  }

  checkPriorityLicense(): boolean {
    return this.subscription?.name?.toLowerCase().includes('prioritätslizenz') ?? false;
  }

  private askAndHandlePrioritization(): void {
    const productIdSnapshot = this.selectedProductId;
    if (!productIdSnapshot) return;
    this.selectedProductId = null;
    this.dialogService.openConfirmDialog(
      'Produkt lizenziert',
      'Nein',
      'Ja',
      'Möchten Sie das Produkt entsprechend Ihrem Tarif priorisieren?'
    ).subscribe((result) => {
      if (!result) return;
      this.loading = true;
      this.stripeService.prioritizeProduct(this.activeOrg, this.selectedSubObject.originListing.subscriptionId, productIdSnapshot.toString(), true)
        .pipe(finalize(() => { this.loading = false;}))
        .subscribe({
          next: (prioritizeResponse) => {
            if (prioritizeResponse === null) return;
            if (prioritizeResponse?.status !== 200) {
              console.error('Failed to prioritize product.', prioritizeResponse);
              this.dialogService.openDialog(
                'Priorisierung fehlgeschlagen',
                'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
              );
            } else {
              this.dialogService.openDialog('Produkt priorisiert', 'Das Produkt wird jetzt priorisiert angezeigt.');
              this.loadProductsList();
            }
          },
          error: (err) => {
            console.error('Unexpected error while prioritizing product.', err);
          }
        });
    });
  }

  loadProductsList(): void {
    this.loading = true;
    this.stripeService.getAllListingProductFromOrgId(this.activeOrg)
    .pipe(finalize(() => { 
      this.loading = false; 
      this.cdr.markForCheck();
    }))
    .subscribe({
      next: (data) => {
        this.handleProductsListResult(data);
      }, 
      error: (err) => { console.error( 'Unexpected error while loading listing products.', err); }
    });
  }

  /**
   * Finds the subscription object that matches the current subscription ID
   */
  private findMatchingSubscription(data: any[]): any | null {
    return data.find(item => {
      const originMatch = item.originListing?.subscriptionId === this.subscription.id;
      const prioMatch = item.prioListing?.subscriptionId === this.subscription.id;
      return this.isPriorityLicense ? prioMatch : originMatch;
    });
  }

  /**
   * Processes licensed and filtered products based on subscription type
   */
  private processProducts(data: any[], selectedSubObject: any): void {
    if (this.isPriorityLicense) {
      this.processPriorityLicense(selectedSubObject);
    } else {
      this.processOriginLicense(data, selectedSubObject);
    }
  }

  /**
   * Process products for priority license
   */
  private processPriorityLicense(selectedSubObject: any): void {
    const prioListing = selectedSubObject.prioListing;
    const originListing = selectedSubObject.originListing;

    // Get licensed products from priority listing (empty array if no products)
    const prioProducts = prioListing?.products || [];
    const prioProductIds = new Set(prioProducts.map(String));
    this.licensedProducts = this.availableProducts.filter(
      product => prioProductIds.has(String(product.id))
    );

    // Get products that can be prioritized (licensed in origin but not yet prioritized)
    const originProducts = originListing?.products || [];
    const availableForPrioritization = originProducts.filter(
      id => !prioProductIds.has(String(id))
    );

    this.filteredProducts = this.availableProducts.filter(
      product => availableForPrioritization.includes(String(product.id))
    );
  }

  /**
   * Process products for origin license
   */
  private processOriginLicense(data: any[], selectedSubObject: any): void {
    const originListing = selectedSubObject.originListing;

    // Get licensed products for current subscription (empty array if no products)
    const currentProducts = originListing?.products || [];
    const currentProductIds = new Set(currentProducts.map(String));
    this.licensedProducts = this.availableProducts.filter(
      product => currentProductIds.has(String(product.id))
    );

    // Get all licensed product IDs across all subscriptions
    const allLicensedProductIds = this.getAllLicensedProductIds(data);

    // Filter out already licensed products (from ANY subscription in the org)
    this.filteredProducts = this.availableProducts.filter(
      product => !allLicensedProductIds.has(String(product.id))
    );
  }

  /**
   * Gets all licensed product IDs from all subscriptions in the organization
   */
  private getAllLicensedProductIds(data: any[]): Set<string> {
    const allLicensedProductIds = new Set<string>();

    data.forEach(item => {
      if (Array.isArray(item.originListing?.products)) {
        item.originListing.products.forEach(id => {
          allLicensedProductIds.add(String(id));
        });
      }
    });

    return allLicensedProductIds;
  }

  handleRemoveProduct(product: any): void {
    if (this.checkPriorityLicense()) {
      this.removePriorization(product.id);
    } else {
      this.removeEntry(product);
    }
  }

  handleAddProduct(): void {
    if (!this.selectedProductId) { 
      return;
    }

    if (this.checkPriorityLicense()) {
      this.addPriorization();
    } else {
      this.addOneEntry();
    }
  }

  private isCapacityFull(): boolean {
    if (!this.capacity) {
      return false;
    }
    const [current, max] = this.capacity.split('/').map(Number);
    return current >= max;
  }

  /**
   * Shows dialog when capacity is full
   */
  private showCapacityFullDialog(): void {
    this.dialogService.openDialog(
      'Die Kapazität Ihrer Lizenz ist erreicht',
      'Bitte entfernen Sie zunächst ein Produkt aus Ihrer Lizenz, bevor Sie ein neues hinzufügen.'
    );
  }

  /**
   * Handles the result of the capacity query. Checks for errors and updates the local capacity variable.
   * 
   * @param data - The result from the getListingCurrentUsage() call.
   * @returns 
   */
  private handleCapacityResult(data: any): void {
    if (data && typeof data === 'object' && 'status' in data && data.status >= 400) {
      console.error('Failed to load subscription capacity.', data);
      return;
    }
    if (data?.capacity) {
      this.capacity = data.capacity;
    }
  }

  /**
   * Handles the loaded subscription data and product lists.
   * Sorts the data, finds the matching subscription, and processes the licensed and filtered products based on the license type.
   * Displays a dialog if an error occurs.
   * 
   * @param data - Array of listing objects containing subscription and product information.
   * @returns 
   */
  private handleProductsListResult(data: any): void {
    if (data?.status >= 400) {
      console.error('Failed to load listing products.', data);
      this.dialogService.openDialog(
        'Produkte konnten nicht geladen werden',
        'Bitte versuchen Sie es später erneut.'
      );
      return;
    }
    this.productFromListing = data.sort((a, b) => b.originListing.id - a.originListing.id);
    this.selectedSubObject = this.findMatchingSubscription(data);
    if (this.selectedSubObject) {
      this.processProducts(data, this.selectedSubObject);
    } else {
      this.licensedProducts = [];
      this.filteredProducts = [];
    }
  }

  /**
   * Handles the loaded payment method data.
   * Stores all payment methods and links the subscription's current payment method to the corresponding card data.
   * Displays a dialog if an error occurs.
   * 
   * @param data - Array of payment methods
   * @returns 
   */
  private handlePaymentResult(data: any): void {
    if (data && typeof data === 'object' && 'status' in data && data.status >= 400) {
      console.error('Failed to load payment data.', data);
      this.dialogService.openDialog(
        'Zahlungsdaten konnten nicht geladen werden',
        'Bitte versuchen Sie es später erneut.'
      );
      return;
    }
    if (data && Array.isArray(data)) {
      this.allPaymentData = data;
      data.forEach(elem => {
        if (elem.id === this.subscription.paymentId) {
          this.paymentData = elem;
        }
      });
    }
  }
}
